import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SellersProps } from "components/types";

export interface AuthState {
  token: string;
  user: any;
  selectedSellers: SellersProps[];
  notificationToggle: boolean;
  nav: boolean;
  subscription: any;
}

export const initialState: AuthState = {
  token: "",
  user: {},
  nav: false,
  selectedSellers: [],
  notificationToggle: false,
  subscription: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addToken: (state: AuthState, action: PayloadAction<string>) => {
      state.token = action.payload;
    },

    addUserDetails: (state: AuthState, action: PayloadAction<any>) => {
      state.user = action.payload;
    },

    addSelectedSellers: (
      state: AuthState,
      action: PayloadAction<SellersProps[]>
    ) => {
      state.selectedSellers = action.payload;
    },

    removeToken: () => {
      localStorage.removeItem("persist:root");
      localStorage.clear();
      return initialState;
    },

    openNavigation: (state) => {
      state.notificationToggle = true;
    },

    closeNavigation: (state) => {
      state.notificationToggle = false;
    },

    removeAllSellers: (state) => {
      state.selectedSellers = state.selectedSellers.map(
        (item: SellersProps) => ({ ...item, checked: false })
      );
    },

    addSubscriptionDetails: (state: AuthState, action: PayloadAction<any>) => {
      state.subscription = action.payload;
    },

    removeSelectedSeller: (state: AuthState, action: PayloadAction<string>) => {
      state.selectedSellers = state.selectedSellers.map((item: SellersProps) =>
        item.id === action.payload ? { ...item, checked: false } : item
      );
    },

    clearAuthState: () => {
      return initialState;
    },

    toggleNav: (state: AuthState, action: PayloadAction<boolean>) => {
      state.nav = action.payload;
    },
  },
});

export const {
  addToken,
  removeToken,
  addUserDetails,
  addSelectedSellers,
  removeSelectedSeller,
  removeAllSellers,
  clearAuthState,
  openNavigation,
  closeNavigation,
  toggleNav,
  addSubscriptionDetails,
} = authSlice.actions;
